<template>
    <div id="plans-component">
        <b-modal v-model="modalShow" id="modal-plans" hide-footer size="xl" centered ref="modal-plans" scrollable
            title="Agregar Plan">
            <form id="formCrud" class="formCrud">
                <div class="row">
                    <div class="col-12 col-md-3">

                        <select v-model="tipoPlan.package_id" data-select="on" class="required" data-name-input="Plan">
                            <option :value="0">Selecciona un Plan</option>
                            <option v-for="plan in packagesArray" :value="plan.id" :key="plan.id">
                                {{ plan.paquete }}
                            </option>
                        </select>
                    </div>
                    <div class="col-12 col-md-3">
                        <select v-model="tipoPlan.kind_plan" data-select="on" class="required"
                            data-name-input="Paquete">
                            <option :value="0">Selecciona un Paquete</option>
                            <option :value="1">Individual</option>
                            <option :value="2">Familiar</option>
                            <option :value="3">Colectivo</option>
                        </select>
                    </div>
                    <div class="col-12 col-md-3">
                        <input type="text" class="al-inputs required scr-input" placeholder="Nombre del Plan"
                            v-model="tipoPlan.plan" id="plan" />
                        <label for="plan" class="scr-supertext scr-extra">Nombre del Plan</label>
                    </div>
                    <div class="col-12 col-md-3">
                        <input type="number" class="al-inputs required scr-input" placeholder="Descuento"
                            v-model="tipoPlan.descuento" id="descuento" />
                        <label for="descuento" class="scr-supertext scr-extra">Descuento</label>
                    </div>
                    <div class="col-12 col-md-3">
                        <input type="number" class="al-inputs required scr-input" placeholder="Mínimo de Personas"
                            v-model="tipoPlan.min_per" id="min_per" />
                        <label for="min_per" class="scr-supertext scr-extra">Mínimo de Personas</label>
                    </div>
                    <div class="col-12 col-md-3">
                        <input type="number" class="al-inputs required scr-input" placeholder="Gasto"
                            v-model="tipoPlan.gasto" id="gasto" />
                        <label for="gasto" class="scr-supertext scr-extra">Gasto</label>
                    </div>
                    <div class="col-12 col-md-3">
                        <input type="number" class="al-inputs required scr-input" placeholder="Costo"
                            v-model="tipoPlan.costo" id="costo" />
                        <label for="costo" class="scr-supertext scr-extra">Costo</label>
                    </div>
                    <div class="col-12 col-md-3">
                        <input type="number" class="al-inputs required scr-input" placeholder="Costo por Adicional"
                            v-model="tipoPlan.vug" id="vug" />
                        <label for="vug" class="scr-supertext scr-extra">Vida y Últimos Gastos</label>
                    </div>
                    <div class="col-12 col-md-3">
                        <input type="number" class="al-inputs required scr-input" placeholder="Recupera 90"
                            v-model="tipoPlan.r90" id="r90" />
                        <label for="r90" class="scr-supertext scr-extra">Recupera 90</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-2 offset-sm-5">
                        <button id="dyn-button" type="button" class="formSubmit" v-on:click="guardar()">{{
                            tituloBtn
                        }}
                        </button>
                    </div>
                </div>
            </form>
        </b-modal>
        <main id="mainContent" class="padFixBoth">

            <div class="view">
                <div class="barSettings">
                    <div class="row">
                        <div class="col-12 col-xl-3 mb-3 mb-sm-0">
                            <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3"
                                v-model="pagination.current_page" :total-rows="pagination.total"
                                :per-page="pagination.per_page" aria-controls="my-table"
                                v-on:change="onChange"></b-pagination>
                        </div>
                        <div class="col-12 col-xl-5 mb-3 mb-sm-0">
                            <input id="filter-input" class="al-inputs scr-input" v-model="filter" type="search"
                                placeholder="Buscar por palabra">
                            <label for="filter-input" class="scr-supertext scr-extra">Buscar por palabra</label>
                        </div>
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0 cont_select">
                            <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                                <option :value="10">10</option>
                                <option :value="20">20</option>
                                <option :value="30">30</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                        <div class="col-12 col-md-2 mb-3 mb-sm-0">
                            <button class="formSubmit" type="button" v-on:click="modalShow = true">Agregar Plan</button>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <b-table responsive id="my-table" striped hover :fields="fields" :busy="isBusy"
                            :items="pagination.data" show-empty :sort-by.sync="sortBy" :filter="filter"
                            :sort-desc.sync="sortDesc">
                            <template #head(acciones)="{ item }">
                                <i class="fa-solid fa-gear"></i>
                            </template>
                            <template #empty="scope">
                                <h4 class="emptyRow">
                                    No hay datos para mostrar.
                                </h4>
                            </template>
                            <template #cell(plan)="{ item }">
                                <span>{{ item.relpaquete?.paquete }}</span>
                            </template>
                            <template #cell(paquete)="{ item }">
                                <span>{{ item.plan }}</span>
                            </template>
                            <template #cell(descuento)="data">
                                {{ data.item.descuento }}%
                            </template>
                            <template #cell(personas)="{ item }">
                                {{ item.min_per }}
                            </template>
                            <template #cell(gasto)="{ item }">
                                {{ item.gasto }}
                            </template>
                            <template #cell(costo)="{ item }">
                                {{ item.costo }}
                            </template>
                            <template #cell(adicional)="{ item }">
                                {{ item.vug }}
                            </template>
                            <template #cell(gasto_adicional)="{ item }">
                                {{ item.r90 }}
                            </template>
                            <template #cell(acciones)="{ item }">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button"
                                        id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                        aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="javascript:void(0)"
                                            v-on:click="updateReg(item)">Editar</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                            v-on:click="onClickDelete(item.id)">Borrar</a>
                                    </div>
                                </div>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Cargando...</strong>
                                </div>
                            </template>

                        </b-table>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import { myMixins } from "../mixins/myMixins";
import { packagesService } from "../../Services/Packages.service";
import { plansService } from "../../Services/Plans.service";

export default {
    name: "plans",
    mixins: [myMixins],
    data() {
        return {
            sortBy: 'Paquete',
            sortDesc: false,
            modificar: false,
            isBusy: false,
            filter: null,
            tituloBtn: "Guardar",
            modalShow: false,
            tipoPlan: {
                package_id: 0,
                plan: "",
                kind_plan: 0,
                descuento: "",
                min_per: "",
                gasto: "",
                costo: "",
                vug: "",
                r90: "",
                id: ''
            },
            params: {
                limit: 10,
                page: 1,
                where: []
            },
            fields: [
                { key: "plan" },
                { key: "paquete" },
                { key: "descuento" },
                { key: "personas" },
                { key: "gasto" },
                { key: "costo" },
                { key: "vug" },
                { key: "r90" },
                { key: "acciones" }
            ],
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            packagesArray: [],
        };
    },
    methods: {
        async index() {
            this.isBusy = true;
            this.packagesArray = await packagesService.getMany();
            this.pagination = await plansService.getMany(this.params);
            this.isBusy = false;
        },
        async onClickDelete(id) {
            let resp = await plansService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async guardar() {

            let resp = '';
            let respVal = this.valFormulariosV3();
            if (respVal) {
                this.disableSubmitBtn(true);
                if (this.modificar) {
                    resp = await plansService.updateOne(this.tipoPlan.id, this.tipoPlan);
                    this.modificar = false;
                } else {
                    resp = await plansService.saveOne(this.tipoPlan);
                }
                this.disableSubmitBtn(false);
            }

            if (resp.process === 'success') {
                this.modalShow = false;
                this.setEmpty();
                this.getAlert(resp.process);
                await this.index();

            } else {
                //this.getAlert(resp.process, 'fail');
            }
            this.modificar = false;

        },
        async onChange(page) {
            this.params.page = page;
            await this.index();
        },
        updateReg(data = {}) {
            this.modalShow = true;
            this.tipoPlan = data;
            this.tituloBtn = "Actualizar";
            this.modificar = true;
        },
        changeLimit() {
            this.index();
        },
        setEmpty() {
            this.tipoPlan = {
                package_id: "",
                plan: "",
                kind_plan: 0,
                descuento: "",
                min_per: "",
                gasto: "",
                costo: "",
                vug: "",
                r90: "",
                id: ''
            }
        }
    },
    mounted() {
        this.index();
    },
}
</script>
<style scoped>
form select {
    margin: 0 !important;
}
</style>
